export interface ThemeType {
  white: string;
  black: string;
  lightBlack: string;
  gray: string;
  lightergray: string;
  lightgray: string;
  transparent: string;
  //
  main: string;
  sub: string;
  darkSub: string;
  darkerSub: string;
  darkMain: string;
  lightMain: string;
  lightSub: string;
  textColor: string;
  accent: string;
  lightAccent: string;
  //
  danger: string;
  warning: string;
  caution: string;
  positive: string;
  success: string;
  //
  lead: string;
  onLead: string;
  contact: string;
  onContact: string;
  junk: string;
  onJunk: string;
  leadTask: string;
  onLeadTask: string;
  contactTask: string;
  onContactTask: string;
  kanbanTask: string;
  onKanbanTask: string;
  orphanTask: string;
  onOrphanTask: string;
  //
  whatsapp: string;
  facebook: string;
  googleDrive: string;
}

const transparent = "transparent";
const whatsapp = "#25d366";
const facebook = "#1877f2";
const googleDrive = "#0f9d58";

export const PurpleTheme: ThemeType = {
  white: "#ffffff",
  black: "#000",
  lightBlack: "#222",
  gray: "gray",
  lightergray: "#c6c6c6",
  lightgray: "#d5d5d5",
  transparent,

  main: "#803588",
  sub: "#ebebeb",
  darkSub: "#d6d6d6",
  darkerSub: "#929292",
  darkMain: " #5b0d64",
  lightMain: " #934599",
  lightSub: "#f8f9fa",
  textColor: "#000",
  accent: "#5369a9",
  lightAccent: "#697ebc",
  //
  danger: "#dc3545",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",
  //
  lead: "#697ebc",
  onLead: "#ffffff",
  contact: "#803588",
  onContact: "#ffffff",
  junk: "#929292",
  onJunk: "#000000",
  leadTask: "#697ebc",
  onLeadTask: "#ffffff",
  contactTask: "#803588",
  onContactTask: "#ffffff",
  kanbanTask: "#929292",
  onKanbanTask: "#000000",
  orphanTask: "#dc3545",
  onOrphanTask: "#ffffff",
  //
  whatsapp,
  facebook,
  googleDrive,
};

export const SlateTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#1b1f24",

  gray: "#6b7280",
  lightergray: "#a8b0bb",
  lightgray: "#c3c9d1",

  transparent,

  main: "#2f4f6f",
  darkMain: "#233c54",
  lightMain: "#3e647f",

  sub: "#eef1f4",
  darkSub: "#d3d9df",
  darkerSub: "#9aa3ad",
  lightSub: "#f7f9fb",

  textColor: "#0f172a",

  accent: "#5a7c9a",
  lightAccent: "#7f9fb9",

  danger: "#dc3545",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#4a6fa5",
  onLead: "#ffffff",
  leadTask: "#4a6fa5",
  onLeadTask: "#ffffff",

  contact: "#3f7f74",
  onContact: "#ffffff",
  contactTask: "#3f7f74",
  onContactTask: "#ffffff",

  junk: "#8b93a1",
  onJunk: "#000000",

  kanbanTask: "#5f6f82",
  onKanbanTask: "#ffffff",

  orphanTask: "#8b2c2c",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};

export const TerraTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#1c1c1c",

  gray: "#8b8b8b",
  lightergray: "#bfb5aa",
  lightgray: "#d6cfc4",

  transparent,

  main: "#a66e4a",
  darkMain: "#82543a",
  lightMain: "#c18b63",

  sub: "#f4f2ef",
  darkSub: "#d9d6d3",
  darkerSub: "#a09b97",
  lightSub: "#fbf9f6",

  textColor: "#1c1c1c",

  accent: "#c1a661",
  lightAccent: "#dbc38c",

  danger: "#dc3545",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#7c8c50",
  onLead: "#ffffff",
  leadTask: "#7c8c50",
  onLeadTask: "#ffffff",

  contact: "#a66e4a",
  onContact: "#ffffff",
  contactTask: "#a66e4a",
  onContactTask: "#ffffff",

  junk: "#bfb5aa",
  onJunk: "#000000",

  kanbanTask: "#946f8b",
  onKanbanTask: "#ffffff",

  orphanTask: "#d9534f",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};

export const ForestTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#1c1c1c",

  gray: "#7e7e7e",
  lightergray: "#b0aeb2",
  lightgray: "#d6d4d1",

  transparent,

  main: "#4a7c59",
  darkMain: "#3a6043",
  lightMain: "#639a70",

  sub: "#f6f5f1",
  darkSub: "#dcd9d4",
  darkerSub: "#a8a59f",
  lightSub: "#fafaf5",

  textColor: "#1c1c1c",

  accent: "#d4b483",
  lightAccent: "#e8d3b2",

  danger: "#e74c3c",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#1e73be",
  onLead: "#ffffff",
  leadTask: "#1e73be",
  onLeadTask: "#ffffff",

  contact: "#38761d",
  onContact: "#ffffff",
  contactTask: "#38761d",
  onContactTask: "#ffffff",

  junk: "#c9b799",
  onJunk: "#000000",

  kanbanTask: "#d9822b",
  onKanbanTask: "#ffffff",

  orphanTask: "#e74c3c",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};

export const YellowTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#1a1a1a",

  gray: "#777777",
  lightergray: "#b5b5b5",
  lightgray: "#c7c7c7",

  transparent,

  main: "#cc9a4f",
  darkMain: "#a87d38",
  lightMain: "#d7aa63",

  sub: "#e8e8e8",
  darkSub: "#c8c8c8",
  darkerSub: "#9e9e9e",
  lightSub: "#f6f6f6",

  textColor: "#111111",

  accent: "#a88322",
  lightAccent: "#d5b55a",

  danger: "#dc3545",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#55669a",
  onLead: "#ffffff",

  leadTask: "#55669a",
  onLeadTask: "#ffffff",

  contact: "#cc9a4f",
  onContact: "#ffffff",
  contactTask: "#cc9a4f",
  onContactTask: "#ffffff",

  junk: "#9e9e9e",
  onJunk: "#ffffff",

  kanbanTask: "#9e9e9e",
  onKanbanTask: "#ffffff",

  orphanTask: "#566b2d",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};

export const ScarletTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#1a0507",

  gray: "#7a6367",
  lightergray: "#b6979d",
  lightgray: "#d5bcc1",

  transparent,

  main: "#b3261e",
  darkMain: "#861214",
  lightMain: "#d33b34",

  sub: "#f7f1f2",
  darkSub: "#e0cdd1",
  darkerSub: "#a6838a",
  lightSub: "#fdf7f8",

  textColor: "#190608",

  accent: "#6d1b1b",
  lightAccent: "#8a2c2c",

  danger: "#c1121f",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#8b1e3f",
  onLead: "#ffffff",

  contact: "#b3261e",
  onContact: "#ffffff",

  junk: "#b6979d",
  onJunk: "#000000",

  leadTask: "#5b2a86",
  onLeadTask: "#ffffff",

  contactTask: "#b3261e",
  onContactTask: "#ffffff",

  kanbanTask: "#a65c3a",
  onKanbanTask: "#ffffff",

  orphanTask: "#c1121f",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};

export const OceanTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#0b1720",

  gray: "#6b7280",
  lightergray: "#9ca3af",
  lightgray: "#cbd5e1",

  transparent,

  main: "#1f6f8b",
  darkMain: "#174a5b",
  lightMain: "#2c8cb0",

  sub: "#e5f3f8",
  darkSub: "#c7e0eb",
  darkerSub: "#8fb4c6",
  lightSub: "#f2f9fc",

  textColor: "#071923",

  accent: "#0ea5e9",
  lightAccent: "#38bdf8",

  danger: "#dc3545",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#2563eb",
  onLead: "#ffffff",
  leadTask: "#2563eb",
  onLeadTask: "#ffffff",

  contact: "#059669",
  onContact: "#ffffff",
  contactTask: "#059669",
  onContactTask: "#ffffff",

  junk: "#9ca3af",
  onJunk: "#000000",

  kanbanTask: "#0ea5e9",
  onKanbanTask: "#ffffff",

  orphanTask: "#b3261e",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};

export const MintTheme: ThemeType = {
  white: "#ffffff",
  black: "#000000",
  lightBlack: "#102019",

  gray: "#6b7280",
  lightergray: "#a1aab6",
  lightgray: "#cfd4dd",

  transparent,

  main: "#2fa37f",
  darkMain: "#1d7a5d",
  lightMain: "#52c9a3",

  sub: "#f3fdf8",
  darkSub: "#cceee0",
  darkerSub: "#8fd0b3",
  lightSub: "#f9fffb",

  textColor: "#052e23",

  accent: "#f4a261",
  lightAccent: "#f6c391",

  danger: "#dc3545",
  warning: "#fd7e14",
  caution: "#ffc107",
  positive: "#28a745",
  success: "#198754",

  lead: "#2b6cb0",
  onLead: "#ffffff",
  leadTask: "#2b6cb0",
  onLeadTask: "#ffffff",

  contact: "#2fa37f",
  onContact: "#ffffff",
  contactTask: "#2fa37f",
  onContactTask: "#ffffff",

  junk: "#a1aab6",
  onJunk: "#000000",

  kanbanTask: "#f4a261",
  onKanbanTask: "#000000",

  orphanTask: "#c05621",
  onOrphanTask: "#ffffff",

  whatsapp,
  facebook,
  googleDrive,
};
